<div class="settings-general">
	<div class="card-block grid-column-one-full">
		<div class="card-title">
			<span class="card-title-label" translate>user.card.security.change-login-title</span>
		</div>

		<form class="card-block-body" [formGroup]="userForm">
			<div class="flex-2" *ngIf="userInfo">
				<mat-form-field class="card-info-value" (click)="enableChangeButton" floatLabel="always">
					<mat-label translate>user.card.security.your-login</mat-label>
					<input matInput formControlName="userName" type="text" autocomplete="off" spellcheck="false" (focus)="onEdit()">
					<mat-icon class="input-edit-icon" matSuffix svgIcon="copo_pencil" color="accent"></mat-icon>
					<mat-hint class="mat-error"
						*ngIf="userForm.controls['userName'].dirty && userForm.controls['userName'].invalid"
						translate>user.card.security.username-error</mat-hint>
				</mat-form-field>
				<button mat-flat-button color="primary" mat-ripple type="submit" (click)="onSave()"
					[disabled]="!enableChangeButton || userForm.invalid">
					<span translate>quapp.action.change</span>
				</button>
			</div>
		</form>

		<div class="card-title">
			<span class="card-title-label" translate>user.card.security.change-password-title</span>
		</div>

		<form class="card-block-body" [formGroup]="changePasswordFormGroup" method="post" *ngIf="!loading" (ngSubmit)="updatePassword()">
			<div class="grid-3">
				<input hidden type="text" name="username" autocomplete="username" [value]="userInfo?.username"/>
				<mat-form-field floatLabel="always">
					<mat-label translate>user.card.security.your-current-password</mat-label>
					<input matInput formControlName="currentPwd" [type]="showPassword['currentPassword'] ? 'text' : 'password'" autocomplete="current-password" id="current-password" name="currentpassword" minlength="15"
						required [pattern]="passwordPatternStr">
					<mat-icon *ngIf="!changePasswordFormGroup.get('currentPwd')!.value" class="input-edit-icon" matSuffix svgIcon="copo_pencil" color="accent"></mat-icon>
					<button type="button" *ngIf="changePasswordFormGroup.get('currentPwd')!.value" color="accent" matSuffix mat-icon-button (click)="handlePasswordVisibility('currentPassword')" tabindex="-1">
						<mat-icon [svgIcon]="showPassword['currentPassword'] ? 'md:eye_close' : 'md:eye_open'" class="md-svg-icon"></mat-icon>
					</button>
					<mat-error *ngIf="currentPwd && currentPwd.errors && currentPwd.errors['required'] else otherError" translate>ecall-off.required</mat-error>
					<ng-template #otherError>
						<mat-error translate>settings.password-doesn't-match-rules</mat-error>
					</ng-template>

				</mat-form-field>

				<mat-form-field floatLabel="always">
					<mat-label translate>user.card.security.your-new-password</mat-label>
					<input matInput formControlName="newPwd" [type]="showPassword['newPassword'] ? 'text' : 'password'" autocomplete="new-password" id="new-password" name="newpassword" minlength="15"
						required [pattern]="passwordPatternStr">
					<mat-icon *ngIf="!changePasswordFormGroup.get('newPwd')!.value" class="input-edit-icon" matSuffix svgIcon="copo_pencil" color="accent"></mat-icon>
					<button type="button" *ngIf="changePasswordFormGroup.get('newPwd')!.value" color="accent" matSuffix mat-icon-button (click)="handlePasswordVisibility('newPassword')" tabindex="-1">
						<mat-icon [svgIcon]="showPassword['newPassword'] ? 'md:eye_close' : 'md:eye_open'" class="md-svg-icon"></mat-icon>
					</button>
					<mat-error *ngIf="newPwd && newPwd.errors && newPwd.errors['required'] else otherNewPwdError" translate>ecall-off.required</mat-error>
					<ng-template #otherNewPwdError>
						<mat-error translate>settings.password-doesn't-match-rules</mat-error>
					</ng-template>
				</mat-form-field>

				<mat-form-field floatLabel="always">
					<mat-label translate>user.card.security.your-repeat-new-password</mat-label>
					<input matInput formControlName="confirmNewPwd" [type]="showPassword['confirmPassword'] ? 'text' : 'password'" autocomplete="new-password" id="confirm-password" name="confirmpassword"
						minlength="15" required [pattern]="passwordPatternStr">
					<mat-icon *ngIf="!changePasswordFormGroup.get('confirmNewPwd')!.value" class="input-edit-icon" matSuffix svgIcon="copo_pencil" color="accent"></mat-icon>
					<button type="button" *ngIf="changePasswordFormGroup.get('confirmNewPwd')!.value" color="accent" matSuffix mat-icon-button (click)="handlePasswordVisibility('confirmPassword')" tabindex="-1">
						<mat-icon [svgIcon]="showPassword['confirmPassword'] ? 'md:eye_close' : 'md:eye_open'" class="md-svg-icon"></mat-icon>
					</button>
					<mat-error
						*ngIf="changePasswordFormGroup && confirmNewPwd && confirmNewPwd.errors && confirmNewPwd.errors['required']"
						translate>ecall-off.required</mat-error>
					<mat-error
						*ngIf="changePasswordFormGroup && confirmNewPwd && confirmNewPwd.errors && confirmNewPwd.errors['notMatch']"
						translate>user.card.security.confirm-password-match</mat-error>
				</mat-form-field>
				<button class="change-password-button" mat-flat-button color="primary" mat-ripple type="submit"
					[disabled]="this.changePasswordFormGroup.invalid">
					<span translate>quapp.action.change</span>
				</button>
			</div>
			<mat-error class="wrap-error" *ngIf="passwordError">
				<span>{{errorMessage}}</span>
			</mat-error>
			<div class="rules-box">
				<div class="copo-medium-grey" translate>user.card.security.password-must-contain-title</div>
				<div class="copo-medium-grey" >
					<div>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('charLength')">
							<mat-icon class="copo-green icon-size" svgIcon="md:check"></mat-icon>
						</ng-container>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('charLength')">
							<mat-icon class="copo-orange-text-icon icon-size" svgIcon="close"></mat-icon>
						</ng-container>
						<span [ngClass]="{'copo-orange-text-icon': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('charLength'),
						'copo-green': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('charLength')}" translate>user.card.security.15-character-rule</span>
					</div>
					<div>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('lower')">
							<mat-icon class="copo-green icon-size" svgIcon="md:check"></mat-icon>
						</ng-container>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('lower')">
							<mat-icon class="copo-orange-text-icon icon-size" svgIcon="close"></mat-icon>
						</ng-container>
						<span [ngClass]="{'copo-orange-text-icon': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('lower'),
						'copo-green': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('lower')}" translate>user.card.security.1-lowercase-letter-rule</span>
					</div>
					<div>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('upper')">
							<mat-icon class="copo-green icon-size" svgIcon="md:check"></mat-icon>
						</ng-container>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('upper')">
							<mat-icon class="copo-orange-text-icon icon-size" svgIcon="close"></mat-icon>
						</ng-container>
						<span [ngClass]="{'copo-orange-text-icon': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('upper'),
						'copo-green': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('upper')}" translate>user.card.security.1-uppercase-letter-rule</span>
					</div>
					<div>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('number')">
							<mat-icon class="copo-green icon-size" svgIcon="md:check"></mat-icon>
						</ng-container>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('number')">
							<mat-icon class="copo-orange-text-icon icon-size" svgIcon="close"></mat-icon>
						</ng-container>
						<span [ngClass]="{'copo-orange-text-icon': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('number'),
						'copo-green': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('number')}" translate>user.card.security.1-number-rule</span>
					</div>
					<div>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('special')">
							<mat-icon class="copo-green icon-size" svgIcon="md:check"></mat-icon>
						</ng-container>
						<ng-container *ngIf="changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('special')">
							<mat-icon class="copo-orange-text-icon icon-size" svgIcon="close"></mat-icon>
						</ng-container>
						<span [ngClass]="{'copo-orange-text-icon': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && !match('special'),
						'copo-green': changePasswordFormGroup && changePasswordFormGroup.controls['newPwd'].value && match('special')}" translate>user.card.security.1-special-character-rule</span>
					</div>
				</div>
			</div>
		</form>
		<copo-loading-spinner *ngIf="loading"></copo-loading-spinner>
	</div>
</div>
